import React, { Component } from 'react';
import { connect } from 'react-redux';
// components
import { Callout, FontAwesome } from 'components/ui';
import { Row, Col, Button, Input, UncontrolledTooltip } from 'reactstrap';
import { 
  PlatoonSelect, SoldierSelect,
  Radio, ParshaSelect, BaseSelect, Checkbox
} from 'components/inputs';
// functions
import julian from 'julian';
import { setTitle } from 'functions/utils';
import { isAdmin, isBC } from 'functions/login';
// style
import './PrintPage.scss';
import { LEGACY_URL, V_MASHPIA_PRINT_SCHOOL_ID, V_MASHPIA_PRINT_URL } from 'components/constants';

class PrintPage extends Component {

  state = { 
    school_id: false,   class_ids: [],
    user_ids: [],       parsha_ids: [],
    double_sided: true, dates: 'hebrew'
  };

  componentDidMount() {
    setTitle( 'Print Missions' );
    // set the default school id and class id
    const { school_id, class_id } = this.props.login;
    this.setState({ school_id });
    // set the default class id
    if ( class_id ) {
      this.setState({ class_ids: [ class_id ] });
    }
    // set the default parsha
    if ( this.props.parshos.length > 0 ) {
      this.setDefaultParsha();
    }
  }

  componentDidUpdate( prevProps ) {
    if ( 
      prevProps.parshos !== this.props.parshos && 
      this.props.parshos.length > 0 
    ) this.setDefaultParsha();
  }

  setDefaultParsha() {
    const { parshos } = this.props;
    const today = parseInt( julian( new Date() ), 10 );
    // select the parsha that contains today (the current week)
    const parsha = parshos.find( parsha => parsha.start <= today && parsha.end >= today );
    // Only set parsha_ids if a valid parsha was found
    if (parsha) {
      this.setState({ parsha_ids: [ parsha.id ] });
    }
  }

  showInstructions = () => {
    window.open(
      `${ LEGACY_URL }/mission_report/instructions/`, '_blank', 
      'width=770, height=700, menubar=no, scrollbars=yes, status=no, toolbar=no, titlebar=no'
    );
  }

  schoolChange = ({ value }) => {
    this.setState({ school_id: value })
  };
  multiSelectChange = key => values => this.setState({
    [key]: (values || []).map( val => val.value )
  });

  toggleDates = ( e ) => this.setState({ dates: e.target.value });
  toggleDoubleSided = ( e ) => this.setState({ double_sided: JSON.parse( e.target.value ) });

  render() {
    const {
      school_id, class_ids, user_ids, 
      parsha_ids, double_sided, dates
    } = this.state;

    const { login } = this.props;

    let legacyUrl = '';
    if (school_id === V_MASHPIA_PRINT_SCHOOL_ID && LEGACY_URL === '' && isBC(login.code)) {
      legacyUrl = V_MASHPIA_PRINT_URL;
    } else {
      legacyUrl = `${LEGACY_URL}/api/print/missions`;
    }

    return (
      <div id='PrintPage'>
        <Callout title='Print Missions'>
          <p><strong>Please check the printing instructions below before printing anything.</strong></p>
          <p>
            For performance reasons, printing missions will open in a new tab.
            It may take a while if you are printing missions for many soldiers.{' '}
            <strong>Please be paitient and wait for the pages to finish generating/loading.</strong>
          </p>
        </Callout>

        <form target='_blank' method='post' action={legacyUrl}>
          <Row>
            <Col sm={6}>
              <label>Base</label>
              <BaseSelect
                name='school_id'    onChange={ this.schoolChange } 
                value={ school_id } isDisabled={ !isAdmin( login.code ) } />
              <input type='hidden' value={ school_id } name='school_id' />
            </Col>

            <Col sm={6}>
              <label>Platoon(s)</label>
              <PlatoonSelect 
                placeholder='All Platoons'  isMulti   values={ class_ids }
                isDisabled={ !isBC( login.code ) }    openMenuOnFocus={ false }
                schoolId={ school_id }      onChange={ this.multiSelectChange('class_ids') } />
              <input type='hidden' value={ class_ids } name='class_ids' />
            </Col>

            <Col sm={6}>
              <label>Soldier(s)</label>
              <SoldierSelect 
                values={ user_ids }     isMulti registeredOnly 
                schoolId={ school_id }  classIds={ class_ids }  openMenuOnFocus={ false } 
                onChange={ this.multiSelectChange('user_ids') } placeholder='All Soldiers' />
              <input type='hidden' value={ user_ids } name='user_ids' />
            </Col>

            <Col sm={6}>
              <label>Parsha(s)</label>
              <ParshaSelect 
                isMulti values={ parsha_ids } 
                onChange={ this.multiSelectChange('parsha_ids') } />
              <input type='hidden' value={ parsha_ids } name='parsha_ids'/>
            </Col>
          </Row>

          <Row>
            <Col sm={6} xl={ 3 }>
              <label>Double sided</label><br/>
              <Radio name='double_sided' checked={ double_sided }
                  value={ true } onChange={ this.toggleDoubleSided }>
                I <strong>am</strong> printing double sided copies.
              </Radio><br/>
              <Radio name='double_sided' checked={ !double_sided }
                  value={ false } onChange={ this.toggleDoubleSided }>
                I am <strong>not</strong> printing double sided copies.
              </Radio>
            </Col>

            <Col sm={6} xl={ 3 }>
              <label>Dates</label><br/>
              <Radio name='dates' checked={ dates === 'none' } 
                  value='none' onChange={ this.toggleDates }>
                <strong>No</strong> dates.
              </Radio>
              <Radio name='dates' checked={ dates === 'hebrew' }
                  value='hebrew' onChange={ this.toggleDates }>
                <strong>Hebrew</strong> dates.
              </Radio><br/>
              <Radio name='dates' checked={ dates === 'english' }
                  value='english' onChange={ this.toggleDates }>
                <strong>Hebrew and English</strong> dates.
              </Radio>
            </Col>

            <Col sm={12} xl={ 6 }>
              <label id='pages'>Minimum Number of pages</label>
              <UncontrolledTooltip placement="top" target="pages" autohide={ false }>
                <strong>If entered,</strong> the print generator will generate blank pages{' '}
                to make sure that each soldier has at least this number of pages.<br/>
              </UncontrolledTooltip>
              <Input name='pages' type='number' min={ double_sided ? 2 : 1 } step={ double_sided ? 2 : 1 }/>
            </Col>
          </Row>

          <Row>
            <Col sm={ 12 }>
              <label>Print Jobs</label><br />
              <Checkbox name='batches'>Print in separate print jobs</Checkbox>
            </Col>
          </Row>

          <Row className='buttons'>
            <Col sm={6}>
              <Button color='primary' onClick={ this.showInstructions }>
                <FontAwesome icon='clipboard-list'/> Printing Instructions
              </Button>
            </Col>

            <Col sm={6}>
              <Button color='primary'>
                <FontAwesome icon='print'/> Print
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ login, missions }) => {
  return {
    login: login.current_login,
    parshos: missions.parshos.parshos
  }
};

const mapDispatchToProps = {};

export default connect( mapStateToProps, mapDispatchToProps )( PrintPage );



// WEBPACK FOOTER //
// ./src/pages/missions/print/PrintPage.jsx